import { useTranslation } from "react-i18next";

const SUPPORTED_LANGS = ["en", "nl"] as const;

/**
 * Returns a function to generate language-prefixed paths.
 * e.g. lp("/about") => "/en/about" or "/nl/about"
 */
export function useLangPath() {
    const { i18n } = useTranslation();
    const lang = (SUPPORTED_LANGS as readonly string[]).includes(i18n.language)
        ? i18n.language
        : "en";

    return (path: string): string => {
        if (path === "/" || path === "") return `/${lang}`;
        const normalized = path.startsWith("/") ? path : `/${path}`;
        return `/${lang}${normalized}`;
    };
}
